import {RSAA} from "redux-api-middleware";
import {API_ENDPOINT, AUTH_HEADERS} from "../../util/constants";
import * as types from "../types";
import {handleUnauthorizedAccess} from "../../util/utility";

export function changeMobileNumber(token, api_token,data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/broadcaster/change-number?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data),
            types: [types.CHANGE_MOBILE_NUMBER_REQUEST, types.CHANGE_MOBILE_NUMBER_RECEIVE,{
                type: types.CHANGE_MOBILE_NUMBER_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetChangeMobileNumber = () => ({
    type: types.RESET_CHANGE_MOBILE_NUMBER,
    payload: null
});